import { Box, Typography, Link as MuiLink } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Star } from '@mui/icons-material';

const HeaderContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 10,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2, 2),
  backgroundColor: 'white',
  backdropFilter: 'blur(8px)',
  borderBottom: '1px solid #EAECEF',
  boxShadow: 'none',
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(2, 5)
  }
}));

const Logo = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  color: '#111827'
}));

const NavLinks = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(3)
}));

const ProfileHeader = () => {
  return (
    <HeaderContainer>
      <Logo>
        <Box
          sx={{
            width: 32,
            height: 32,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#4F46E5'
          }}
        >
          <Star sx={{ fontSize: 28 }} />
        </Box>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            fontSize: '1.125rem',
            letterSpacing: '-0.015em'
          }}
        >
          RiteReview
        </Typography>
      </Logo>
      <NavLinks>
        <MuiLink
          href="#"
          underline="none"
          sx={{
            fontSize: '0.875rem',
            fontWeight: 500,
            color: '#6B7280',
            '&:hover': {
              color: '#111827'
            }
          }}
        >
          Help
        </MuiLink>
        <MuiLink
          href="#"
          underline="none"
          sx={{
            fontSize: '0.875rem',
            fontWeight: 500,
            color: '#6B7280',
            '&:hover': {
              color: '#111827'
            }
          }}
        >
          Support
        </MuiLink>
      </NavLinks>
    </HeaderContainer>
  );
};

export default ProfileHeader;

